module.exports = __webpack_public_path__ + "static/img/xgyuan.ffc2c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xgyuan.png
// module id = NjIY
// module chunks = 0